/**
 * @file index.tsx
 *
 * @fileoverview Will forward a path to the corresponding component. In the case of jobiqo this
 * can be a Ladning page, job page, or other pages where the route is defined in drupal.
 */

import React from 'react';
import { Entity, LandingPageFragment } from '~/jobiqo/models/entity';
import { User } from '~/jobiqo/models/user';
import { ApolloError } from '@apollo/client';
import LandingPage from '~/jobiqo/components/Landingpage';
import { PageNotFound } from '~/jobiqo/pages/404';
import { CenterBox } from '~/vcl/atoms/06-layout/01-alignment/02-center-box';

interface RouterProps {
  path: string;
  /**
   * If the user is authenticated.
   */
  authenticated: boolean;
  /**
   * The user roles.
   */
  user: User;
  /**
   * The data for the queries ran on the server.
   */
  data: any;
  /**
   * If the data is loading.
   */
  loading: boolean;
  /**
   * If there was an error getting data.
   */
  error: ApolloError | undefined;
}

export const Router = ({
  path,
  authenticated,
  user,
  data,
  loading,
  error,
  ...props
}: RouterProps) => {
  if (loading) {
    return <CenterBox>Loading page...</CenterBox>;
  }

  const { content }: { content: Entity } = data.route;
  switch (content && content.__typename) {
    case 'LandingPage': {
      const newEnt = content as LandingPageFragment;
      return (
        <LandingPage
          {...{
            entity: newEnt,
            path: path === '/' ? 'home' : path.replace('/', '-'),
          }}
        />
      );
    }
    default: {
      return <PageNotFound />;
    }
  }
};
